import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=9c5e06ce&"
import script from "./Full.vue?vue&type=script&lang=js&"
export * from "./Full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/containers/Full.vue
// module id = null
// module chunks = 